
angular.module("EMR.Home")
    //verfiy Application in emergency web mode
    .value("ApplicationMode", {
        IsEmergencyWeb: false,
        isAddModifyEntirePatientChartActionsDenied: false
    })
    //To hide Specific elements in Emergency Website
    .directive("hideInEmergencyWebsite", ['ApplicationMode', '$compile', function (ApplicationMode, $compile) {
        return {
            priority: 1000,//setting this directive as high priority
            terminal: ApplicationMode.IsEmergencyWeb ? true : false,//neglect other directives implementation(like ng-model,ng-click,ng-change)
            restrict: "A",//usuage is restricted to only attribute
            link: {

                //this method executes when the link function has started
                pre: function () { },


                //after compilation/binding of the data has completed this method is executed
                post: function ($scope, $element, $attr) {
                    if (ApplicationMode.IsEmergencyWeb) {
                        //$element.css("display", 'none');//this can be overridden with css knowledge
                        //adding class attribute
                        $element.attr("class", "ng-hide");
                    }
                    // ////removing our custom directive to avoid infinite digest
                    //$element.removeAttr($attr.$attr.hideInEmergencyWebsite);
                    //$compile($element)($scope);
                }

            }

        }
        //hide-patient-chart-actions add this directive to add / edit / delete actions in patient chart
    }]).directive("hidePatientChartActions", ['ApplicationMode', 'CurrentEHRView', function (ApplicationMode, CurrentEHRView) {
        return {
            priority: 1001,//setting this directive as high priority
            //  terminal: ApplicationMode.isAddModifyEntirePatientChartActionsDenied ? true : false,//neglect other directives implementation(like ng-model,ng-click,ng-change)
            restrict: "A",//usuage is restricted to only attribute
            link: {
                //this method executes when the link function has started
                pre: function () { },
                //after compilation/binding of the data has completed this method is executed
                post: function ($scope, $element) {
                    if (ApplicationMode.isAddModifyEntirePatientChartActionsDenied && _.includes(CurrentEHRView.view, 'PatientChart')) {
                        $element.remove();
                    }
                }

            }

        }
    }])